import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center justify-space-between" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-h4" }, "Норматив на талон")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: 2,
  class: "font-weight-bold"
}, "Категория граждан", -1)
const _hoisted_3 = ["colspan"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]

import { ref, Ref } from 'vue'
import {
  ConsumptionStandards,
  ConsumptionStandardsService,
  ProductCategory,
  PRODUCT_CATEGORIES_INFO,
  PRODUCT_CATEGORIES_HANDBOOKS_UNITS_FULL,
  enumGetKeys,
  citizenCategoryShorthand,
  citizenCategoryName,
} from '@prodcard/core'
import { createCtx, handleError } from '../../../../helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsumptionStandardsListPage',
  props: {
    consumptionStandardsService: {}
  },
  setup(__props: any) {

const props = __props;


const consumptionStandards: Ref<ConsumptionStandards | undefined> = ref(undefined)
const loading = ref(false)

handleError(async () => {
  consumptionStandards.value = await props.consumptionStandardsService.get(createCtx())
}, loading)

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_v_card, {
        class: "mt-8",
        loading: loading.value,
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_table, { hover: "" }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_2,
                  _createElementVNode("th", {
                    colspan: _unref(enumGetKeys)(_unref(ProductCategory)).length,
                    class: "text-center font-weight-bold"
                  }, " Продовольственная категория ", 8, _hoisted_3)
                ]),
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ProductCategory), (productCategory) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: productCategory,
                      title: `${_unref(PRODUCT_CATEGORIES_INFO)[productCategory].description} ${
                _unref(PRODUCT_CATEGORIES_HANDBOOKS_UNITS_FULL)[productCategory] || ''
              }`,
                      class: "text-center"
                    }, _toDisplayString(_unref(PRODUCT_CATEGORIES_INFO)[productCategory].shorthand), 9, _hoisted_4))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(consumptionStandards.value, (consumptionStandard, citizenCategory) => {
                  return (_openBlock(), _createElementBlock("tr", { key: citizenCategory }, [
                    _createElementVNode("td", {
                      title: _unref(citizenCategoryName)(citizenCategory)
                    }, _toDisplayString(_unref(citizenCategoryShorthand)(citizenCategory)), 9, _hoisted_5),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ProductCategory), (productCategory) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: productCategory,
                        class: "text-center"
                      }, _toDisplayString(consumptionStandard[productCategory]), 1))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    _: 1
  }))
}
}

})